/**
 * 用户配额用量排名
 */

import { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    AddRequestHeaders,
    winWidth, isGTscreenWidth,
    NumberToMillionFormat
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const QuotaRQTC = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                $.ajax({
                    url: `${CNF.api}reports/quota/rqtc`,
                    headers: AddRequestHeaders(),
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            if (data.dat.length > 0) {
                                let newData = [];
                                for (let i = 0; i < data.dat.length; i++) {
                                    newData.push({
                                        type: data.dat[i].type,
                                        token: '总计tokens',
                                        value: data.dat[i].total_tokens,
                                    });
                                    newData.push({
                                        type: data.dat[i].type,
                                        token: '使用tokens',
                                        value: data.dat[i].used_tokens,
                                    });
                                }
                                setData(newData);
                            }
                        }
                        setIsRefresh(false);
                    }
                })
            }
        }
    }, [props, isRefresh]);

    useEffect(() => {
        const chart = new Chart({
            width: winWidth - (props.collapsed ? 80 : 200) - 50,
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '用量配额用量排名',
            subtitle: '展示用户配额用量排名, k表示千级, m表示百万。',
        });

        chart.data(data);

        chart
            .interval()
            .transform({ type: 'sortX', by: 'y', reverse: true, slice: isGTscreenWidth ? 12 : 10 })
            .transform({ type: 'dodgeX' })
            .encode('x', 'type')
            .encode('y', 'value')
            .encode('color', 'token')
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .axis('y', { title: '', labelFormatter: '~s', })
            .axis('x', { title: '组织' })   //  图表最底下名称
            .style('minWidth', 40)
            .style('maxWidth', 60)
            .tooltip({  //  提示框
                items: [
                    { channel: 'y', valueFormatter: (d) => `${NumberToMillionFormat(d)}`, },
                ],
            });

        chart
            .interaction('tooltip', { shared: true })
            .interaction('elementHighlightByColor', { background: true });

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <div id='antv-g2-id' />
}

export default QuotaRQTC;